// extracted by mini-css-extract-plugin
export default {"accountSetup":"account-setup_accountSetup__SIJeP","backButton":"account-setup_backButton__KQuRF","passwordFormWrapper":"account-setup_passwordFormWrapper__07b9v"};